import { render, staticRenderFns } from "./SeminarOrderItem.vue?vue&type=template&id=0aca73da&scoped=true"
import script from "./SeminarOrderItem.vue?vue&type=script&lang=js"
export * from "./SeminarOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca73da",
  null
  
)

export default component.exports